var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestriction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7 22C7.17701 22 2.70001 17.523 2.70001 12C2.70001 6.477 7.17701 2 12.7 2C18.223 2 22.7 6.477 22.7 12C22.7 17.523 18.223 22 12.7 22ZM12.7 20C14.8217 20 16.8566 19.1571 18.3569 17.6569C19.8572 16.1566 20.7 14.1217 20.7 12C20.7 9.87827 19.8572 7.84344 18.3569 6.34315C16.8566 4.84285 14.8217 4 12.7 4C10.5783 4 8.54345 4.84285 7.04316 6.34315C5.54287 7.84344 4.70001 9.87827 4.70001 12C4.70001 14.1217 5.54287 16.1566 7.04316 17.6569C8.54345 19.1571 10.5783 20 12.7 20ZM9.22301 7.109L17.591 15.477C17.2015 16.0236 16.7236 16.5015 16.177 16.891L7.80901 8.523C8.19859 7.97673 8.67647 7.49919 9.22301 7.11V7.109Z",
    fill: "#E7280E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.700012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestriction);
export default __webpack_public_path__ + "static/media/restriction.4dd4c7fa16d8e486a5e7f7918d558318.svg";
export { ForwardRef as ReactComponent };